export default{

  writeErrorResponse (state, data) {
    state.error = data
  },

  writeChangePasswordError (state, data) {
    state.changePassword.errors = data
  },

  updateUser (state, user) {
    state.loginData.request.login = user
  },

  updatePassword (state, pass) {
    state.loginData.request.password = pass
  },

  updateLoginResponse (state, data) {
    if (data.cmd !== 'login') return
    state.loginData.error.error = ''
    state.loginData.request.password = ''
    if (data.error) {
      state.loginData.error = data
    } else {
      localStorage.setItem('token', '?' + data.token)
      state.loginData.request.login = ''
      this._vm.$socket.getInitInfos()
    }
  },

  updateChangePassword (state, data) {
    state.changePassword.errors.splice(
      0, state.changePassword.errors.length)
    if (data.cmd === 'change_password' && data.error !== undefined) {
      state.changePassword.errors.push(data.error)
    }
  },

  updateResetPassword (state, data) {
    state.resetPassword.errors.splice(
      0, state.resetPassword.errors.length)
    if (data.cmd === 'reset_password' && data.error !== undefined) {
      state.resetPassword.errors.push(data.error)
    }
  },

  setAppReady (state, data) {
    state.appReady = data
  },

  setupAskAuthentication (state, data) {
    let richContent = [
      {
        'kind': 'authentication',
        'title': 'Connectez-vous',
        'uuid': data.uuid
      }
    ]
    state.askAuthentication.request.rich_content = richContent
  },

  setRoomForAskAuthenticationRequest (state, data) {
    console.log('ROOM UUID', data)
    state.askAuthentication.request.room = data
  },

  updateRooms (state, data) {
    // create inside the Array a direct self reference [_uuid] for each element in the Array Object
    // for easy reference from the entire application
    // ex: the array element 2 with uuid: 'some-uuid' can be accesed by array['_some-uuid']
    data.data.forEach((element, index) => {
      data.data['_' + element.uuid] = data.data[index]
    })
    state.allRooms.response = data
  },

  updateRoom (state, data) {
    let stateData = state.allRooms.response.data

    data.data.forEach((element, index) => {
      if (stateData.hasOwnProperty('_' + element.uuid)) {
        stateData['_' + element.uuid] = data.data[0]
      } else {
        let pushIndex = stateData.push(data.data[0]) - 1
        stateData['_' + element.uuid] = stateData[pushIndex]
      }
    })
  },

  updateSkills (state, data) {
    // create inside the Array a direct self reference [_uuid] for each element in the Array Object
    // for easy reference from the entire application
    // ex: the array element 2 with uuid: 'some-uuid' can be accesed by array['_some-uuid']
    data.data.forEach((element, index) => {
      data.data['_' + element.uuid] = data.data[index]
    })

    state.allSkills.response = data
  },

  updateMessages (state, data) {
    if (data.hasOwnProperty('error')) {
      data.messages = []
    } else if (data.messages.length > 0) {
      data.firstEvent = data.messages[0].event
      data.lastEvent = data.messages[data.messages.length - 1].event
    }
    state.messages.response = data
  },

  //  lastevent
  updateLastMessages (state, data) {
    if (data.hasOwnProperty('error')) {
      data.messages = []
    }
    data.messages = state.messages.response.messages.concat(data.messages)
    state.messages.response = data
  },

  // fromevent
  updatePreviousMessages (state, data) {
    if (data.hasOwnProperty('error')) {
      data.messages = []
    }
    data.messages = data.messages.concat(state.messages.response.messages)
    state.messages.response = data
  },

  addMessage (state, data) {
    state.messages.response.messages.push(data)
  },

  setRoomForMessageRequest (state, data) {
    state.messages.request.room = data
  },

  setFromeventForMessageRequest (state, data) {
    state.messages.request.fromevent = data
  },

  setLasteventForMessageRequest (state, data) {
    state.messages.request.lastevent = data
  },

  setRoomForJoinRequest (state, data) {
    state.joinRoom.request.room = data
  },

  updateJoinRoomResponse (state, data) {
    state.joinRoom.response = data
  },

  updateOwnSettings (state, data) {
    state.ownSettings.response = data
    state.pause.request.pause = !data.data.paused
  },

  updatePauseSetting (state, data) {
    state.ownSettings.response.data.paused = data
    state.pause.request.pause = !data
  },

  updateAgentSettings (state, data) {
    state.agentSettings.response.data = data
  },

  setAgentUuidForSettingsRequest (state, data) {
    state.agentSettings.request.uuid = data
  },

  setCurrentRoom (state, data) {
    state.currentRoomUuid = data
  },

  updateAgentsList (state, data) {
    state.allAgents.response = data
  },

  setSkilForAgentRequest (state, data) {
    state.allAgents.request.skill = data
  },

  setRoomForCloseRequest (state, data) {
    state.closeRoom.request.room = data
  },

  updateCloseRoomResponse (state, data) {
    state.closeRoom.response = data
  },

  setRoomForBlockRequest (state, data) {
    state.blockRoom.request.room = data
  },

  updateBlockRoomResponse (state, data) {
    state.blockRoom.response = data
  },

  setRoomForTransferRequest (state, data) {
    state.transferRoom.request.room = data
  },

  setSKillForTransferRequest (state, data) {
    state.transferRoom.request.skill = data
  },

  updateTransferRoomResponse (state, data) {
    state.transferRoom.response = data
  },

  setRoomForHistoryRequest (state, data) {
    state.getHistory.request.room = data
  },

  updateHistoryResponse (state, data) {
    state.getHistory.response = data
  },

  setRoomForSendMessage (state, data) {
    state.sendMessage.request.room = data
  },

  setContentForSendMessage (state, data) {
    state.sendMessage.request.content = data
  },

  setRichContentForSendMessage (state, data) {
    state.sendMessage.request.rich_content = data
  },

  setContentForSendProducts (state, data) {
    state.sendProducts.request.content = data
  },

  setRichContentForSendProducts (state, data) {
    state.sendProducts.request.rich_content = data
  },

  setRoomForSendProductsRequest (state, data) {
    state.sendProducts.request.room = data
  },

  updateGetProductsResponse (state, data) {
    state.getProducts.response = data
  },

  setContentForSendLocations (state, data) {
    state.sendLocations.request.content = data
  },

  setRichContentForSendLocations (state, data) {
    state.sendLocations.request.rich_content = data
  },

  setRoomForSendLocationsRequest (state, data) {
    state.sendLocations.request.room = data
  },

  updateHeaderStats (state, data) {
    state.getHeaderStats.response = data
  },

  updateGetStats (state, data) {
    state.getStats.response = data
  },

  setIntervalForGetStats (state, data) {
    state.getStats.request.interval = data
  },

  updateGetCsvStats (state, data) {
    state.getCsvStats.response = data
  },

  setIntervalForGetCsvStats (state, data) {
    state.getCsvStats.request.interval = data
  },

  updateGetSupervisorStats (state, data) {
    state.getSupervisorStats.response.data = data
  },

  setIntervalForGetSupervisorStats (state, data) {
    state.getSupervisorStats.request.interval = data
  },

  setAgentForGetSupervisorStats (state, data) {
    state.getSupervisorStats.request.agent = data
  },

  setSkillForGetSupervisorStats (state, data) {
    state.getSupervisorStats.request.skill = data
  },

  updateGetSupervisorCsvStats (state, data) {
    state.getSupervisorCsvStats.response.data = data
  },

  setIntervalForGetSupervisorCsvStats (state, data) {
    state.getSupervisorCsvStats.request.interval = data
  },

  setAgentForGetSupervisorCsvStats (state, data) {
    state.getSupervisorCsvStats.request.agent = data
  },

  setSkillForGetSupervisorCsvStats (state, data) {
    state.getSupervisorCsvStats.request.skill = data
  },

  updateGetNotes (state, data) {
    state.getNotes.response = data
  },

  updateRoomForGetNotes (state, data) {
    state.getNotes.request.room = data
  },

  updatePendingRequests (state, data) {
    state.pendingRequests = data
  },

  setRoomForSendNote (state, data) {
    state.sendNote.request.room = data
  },

  setSubjectForSendNote (state, data) {
    state.sendNote.request.subject = data
  },

  setContentForSendNote (state, data) {
    state.sendNote.request.content = data
  },

  updateSendNoteResponse (state, data) {
    state.sendNote.response = data
  },

  resetUnreadCount (state, room) {
    state.allRooms.response.data['_' + room].unread_msg = 0
  },

  updateUnreadCount (state, room) {
    state.allRooms.response.data['_' + room].unread_msg += 1
  },

  updateTime (state) {
    state.mainTime = Date.now()
  },

  updateGetZencalls (state, data) {
    state.getZencalls.response = data
  },

  setRoomForLaunchZencall (state, data) {
    state.launchZencall.request.room = data
  },

  setZencallForLaunchZencall (state, data) {
    state.launchZencall.request.zencall = data
  },

  updateLaunchZencallResponse (state, data) {
    state.launchZencall.response = data
  },

  sendPayment (state, data) {
    let richContent = [
      {
        'kind': 'payment',
        'uuid': data.uuid,
        'title': data.title,
        'items': data.items,
        'total': data.total
      }
    ]
    state.sendPayment.request.rich_content = richContent
  },

  setRoomForSendPaymentRequest (state, data) {
    state.sendPayment.request.room = data
  },

  setContentForSendFiles (state, data) {
    state.sendFiles.request.content = data
  },

  setRichContentForSendFiles (state, data) {
    state.sendFiles.request.rich_content = data
  },

  setRoomForSendFilesRequest (state, data) {
    console.log('setRoomForSendFilesRequest', data)
    state.sendFiles.request.room = data
  },

  updateCrmSearchResponse (state, data) {
    // console.log('STATE.CRM.RESULTS', state.crm.results)
    state.crm.results = data.data
  }
}
